import {Component, OnInit,forwardRef, Input, Output, EventEmitter} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Constants } from '../../../../utilities/constants.util';


@Component({
  selector: 'lib-searchable-single-selectbox',
  templateUrl: 'searchable-single-selectbox.component.html',
  styleUrls: ['searchable-single-selectbox.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting:forwardRef(()=>HHSGSharedSearchableSingleSelectboxComponent,),
      multi:true,
    }
    
  ]
})

export class HHSGSharedSearchableSingleSelectboxComponent implements OnInit, ControlValueAccessor {
  searchModeOption: string = Constants.NotificationContains;
  searchExprOption: string = Constants.NotificationName;
  searchTimeoutOption: number = 200;
  minSearchLengthOption: number = 0;
  showDataBeforeSearchOption = false;
  value: string[];

 
  @Input() dataSource: any;
  @Input() disabled = false;
  @Input() isRequired = false;
  @Output() selectedId: EventEmitter<number>  = new EventEmitter();

  constructor() { }

  onChange : (dataSource: any) =>void
  onTouch : () => void;

  onValueChanged(e){
    this.selectedId.emit(e);
    this.onChange(e);
  }

  writeValue(obj: any): void {
    this.value =obj;
  }

  registerOnChange(fn:any): void {
    this.onChange= fn;
  }

  registerOnTouched(fn:any): void {
    this.onTouch=fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
  ngOnInit(): void {}

}

